// utils/scheduleReplay.js

import { getFunctions, httpsCallable } from 'firebase/functions'

/**
 * @param {{ liveId: string;
 *           days: string[];  // ["MONDAY", ...]
 *           time: string;    // "HH:mm" по местному
 *           recurring: boolean;
 *         }} params
 */
export async function scheduleReplay ({ liveId, days, time, recurring }) {
  // Парсим часы и минуты
  const [hour, minute] = time.split(':').map(Number)
  if (
    isNaN(hour) || isNaN(minute) ||
      hour < 0 || hour > 23 ||
      minute < 0 || minute > 59
  ) {
    throw new Error('Time must be in format HH:mm')
  }

  // Карта для getDay()
  const DAY_MAP = {
    SUNDAY:    0,
    MONDAY:    1,
    TUESDAY:   2,
    WEDNESDAY: 3,
    THURSDAY:  4,
    FRIDAY:    5,
    SATURDAY:  6
  }

  const now = new Date()
  const todayDow = now.getDay()

  const nextRuns = days.map(d => {
    const targetDow = DAY_MAP[d.toUpperCase()]
    if (targetDow === undefined) {
      throw new Error(`Invalid day: ${d}`)
    }

    // Считаем ближайший targetDow
    const run = new Date(now)
    let delta = (targetDow - todayDow + 7) % 7
    run.setDate(run.getDate() + (delta === 0 && (
    // если сегодня, но время уже прошло — через неделю
      new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, minute) < now
    ) ? 7 : delta))

    // Устанавливаем ровно тот час/минуту местного времени
    run.setHours(hour, minute, 0, 0)

    // Возвращаем ISO-строку, например "2025-05-05T05:57:00.000Z"
    return run.toISOString()
  })

  // Вызываем функцию
  const functions = getFunctions()
  const fn = httpsCallable(functions, 'createReplaySchedule')
  return (await fn({ liveId, nextRuns, recurring })).data
}
